import { useAuthenticator } from '@aws-amplify/ui-react';

/** The signed-in Cognito user plus auth status, via Amplify. */
export function useCurrentUser() {
  const { user, authStatus, signOut } = useAuthenticator((ctx) => [
    ctx.user,
    ctx.authStatus,
    ctx.signOut,
  ]);

  return {
    user,
    authStatus,
    signOut,
    isAuthenticated: authStatus === 'authenticated',
    isAuthenticating: authStatus === 'configuring',
  };
}
